import { Link } from 'react-router-dom';
import { NotificationPriorityBadge } from '@/modules/notifications/components/NotificationPriorityBadge';
import { modulePaths } from '@/routes/paths';
import type { Notification } from '@/types/notification';

function formatWhen(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString('es-AR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

function entityLink(n: Notification): string | null {
  if (!n.entityId) return null;
  if (n.entityType === 'reservation') {
    return `${modulePaths.reservations}/${n.entityId}`;
  }
  if (n.entityType === 'invoice') {
    return `${modulePaths.billing}/facturas/${n.entityId}`;
  }
  if (n.entityType === 'logisticsOrder') {
    return `${modulePaths.logistics}/${n.entityId}`;
  }
  if (n.entityType === 'commercialOperation') {
    return `${modulePaths.commercial}/operaciones/${n.entityId}`;
  }
  return null;
}

type NotificationItemProps = {
  notification: Notification;
  onMarkRead?: (id: string) => void;
  compact?: boolean;
};

export function NotificationItem({
  notification,
  onMarkRead,
  compact = false,
}: NotificationItemProps) {
  const href = entityLink(notification);

  return (
    <article
      className={
        notification.read
          ? 'notification-item notification-item--read'
          : 'notification-item'
      }
    >
      <div className="notification-item__head">
        <strong>{notification.title}</strong>
        <NotificationPriorityBadge priority={notification.priority} />
      </div>
      <p className="notification-item__message">{notification.message}</p>
      <footer className="notification-item__footer">
        <time className="auth-muted" dateTime={notification.createdAt}>
          {formatWhen(notification.createdAt)}
        </time>
        <div className="notification-item__actions">
          {href ? (
            <Link to={href} className="auth-link">
              Ver detalle
            </Link>
          ) : null}
          {!notification.read && onMarkRead ? (
            <button
              type="button"
              className="auth-button auth-button--secondary notification-item__mark"
              onClick={() => onMarkRead(notification.id)}
            >
              {compact ? 'Leída' : 'Marcar leída'}
            </button>
          ) : null}
        </div>
      </footer>
    </article>
  );
}
